import { UISetting, UISettingType } from "..";

export type SuperBannerCMSConfigurationType = {
    Name: string;
    DisplayMultipleItems: boolean;
    DisplayMobileMode: boolean;
    UISetting: UISettingType;
};

export class SuperBannerCMSConfiguration {
    public Name: string;
    public DisplayMultipleItems: boolean;
    public DisplayMobileMode: boolean;
    public UISetting: UISetting;
    constructor(source: SuperBannerCMSConfigurationType) {
        this.Name = source.Name;
        this.DisplayMultipleItems = source.DisplayMultipleItems;
        this.DisplayMobileMode = source.DisplayMobileMode;
        this.UISetting = new UISetting(source.UISetting);
    }
}